/**
 * 英文语言包（中文原文 → 英文 扁平映射）
 * 采用「中文原文做 key」模式（gettext 风格）：
 * - 组件中以 $t('中文原文') 使用，中文模式下 key 即文案；英文模式按本表查英文，未命中回退中文原文
 * - 新增语言时参照本文件结构：key 用中文原文，value 用目标语言译文
 * - 注意保留 {name}、{count} 等 vue-i18n 插值占位符
 */
export default {
  // app
  '智慧水务管理平台': 'Smart Water Management Platform',
  // common
  '确定': 'OK',
  '取消': 'Cancel',
  '确认': 'Confirm',
  '关闭': 'Close',
  '提示': 'Notice',
  '查询': 'Query',
  '搜索': 'Search',
  '重置': 'Reset',
  '编辑': 'Edit',
  '删除': 'Delete',
  '新增': 'Add',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '已选择 {count} 项': '{count} items selected',
  '确定删除吗?': 'Are you sure you want to delete?',
  '是': 'Yes',
  '否': 'No',
  '其他': 'Other',
  '操作': 'Action',
  '创建时间': 'Created At',
  '创建人': 'Created By',
  '错误': 'Error',
  '成功': 'Success',
  '请求出现错误，请稍后再试': 'Request failed, please try again later',
  // login
  '登录': 'Sign In',
  '请输入帐户名': 'Username',
  '密码': 'Password',
  '请输入用户名!': 'Please enter the username!',
  '请输入密码!': 'Please enter the password!',
  '请输入验证码': 'Captcha',
  '请输入验证码!': 'Please enter the captcha!',
  '自动登陆': 'Auto sign in',
  '微信小程序': 'WeChat Mini Program',
  '微信公众号': 'WeChat Official Account',
  '登录部门选择': 'Select Department',
  '您隶属于多部门，请选择登录部门': 'You belong to multiple departments, please select one',
  '请选择登录部门': 'Select a department',
  '欢迎': 'Welcome',
  '欢迎回来': 'Welcome back',
  '登录失败': 'Sign in failed',
  '您尚未归属部门,请确认账号信息': 'You have not been assigned to a department, please check your account',
  '您输入的验证码不正确!': 'The captcha is incorrect!',
  // header
  '搜索菜单': 'Search Menu',
  '系统首页': 'Home',
  '欢迎您，{name}': 'Welcome, {name}',
  '个人中心': 'Profile',
  '账户设置': 'Account Settings',
  '系统设置': 'System Settings',
  '密码修改': 'Change Password',
  '切换部门': 'Switch Department',
  '清理缓存': 'Clear Cache',
  '退出登录': 'Sign Out',
  '真的要注销登录吗 ?': 'Are you sure you want to sign out?',
  '部门切换': 'Switch Department',
  '刷新缓存完成！': 'Cache refreshed!',
  '刷新缓存失败！': 'Failed to refresh cache!',
  '语言': 'Language',
  // priceItem
  '收费名称': 'Charge Name',
  '请输入收费名称': 'Please enter charge name',
  '请输入收费名称模糊查询': 'Enter charge name to search',
  '请输入收费名称！': 'Please enter the charge name!',
  '该价格名称已存在!': 'This charge name already exists!',
  '收费方式': 'Charge Method',
  '请输入收费方式': 'Please enter charge method',
  '请输入收费方式！': 'Please enter the charge method!',
  '按量收取': 'By volume',
  '收费类型': 'Charge Type',
  '请输入收费类型': 'Please enter charge type',
  '请输入收费类型！': 'Please enter the charge type!',
  '收费价格': 'Charge Price',
  '收费价格(元)': 'Charge Price (CNY)',
  '请输入收费价格': 'Please enter charge price',
  '请输入收费价格！': 'Please enter the charge price!',
  '收费价格有误，请输入2位的小数': 'Invalid price, please enter a decimal with 2 places',
  '收费价格不能超过600!': 'Charge price cannot exceed 600!',
  '元/吨': 'CNY/ton',
  '收取违约金': 'Late Fee',
  '是否收取违约金': 'Late Fee Enabled',
  '请选择是否收取违约金': 'Select whether to charge late fee',
  '请选择是否收取违约金！': 'Please select whether to charge late fee!',
  '计算公式': 'Formula',
  '请输入计算公式': 'Please enter formula',
  '备注': 'Remark',
  '请输入备注': 'Please enter remark',
  // sys
  '系统提示': 'System Notice',
  '拒绝访问': 'Access denied',
  '登录已过期': 'Session Expired',
  '很抱歉，登录已过期，请重新登录': 'Sorry, your session has expired. Please sign in again',
  '重新登录': 'Sign In Again',
  '很抱歉，资源未找到!': 'Sorry, the resource was not found!',
  '网络超时': 'Network timeout',
  '未授权，请重新登录': 'Unauthorized, please sign in again',
  // tab
  '刷 新': 'Refresh',
  '关闭左侧': 'Close Left',
  '关闭右侧': 'Close Right',
  '关闭其它': 'Close Others',
  '首页不能关闭!': 'The home tab cannot be closed!',
  '这是最后一页，不能再关闭了啦': 'This is the last tab and cannot be closed'
}
